import { clearCachedCatalog } from './catalogCache';
import { forgetSavedBasket } from '../hooks/useBasket';

// A staff preview (pages/StaffPreview.jsx) leaves nothing behind when it ends
// or moves to another customer: not its sign-in, not a basket built while
// looking, not a catalog priced for that customer. `user` is the signed-in
// token's claims; a real customer's basket is never touched.
export function leavePreview(user) {
  try { localStorage.removeItem('ss_token'); } catch { /* storage blocked */ }
  if (user?.preview) forgetSavedBasket(user.customerId);
  clearCachedCatalog();
}
